// AppAlarmSetting.jsx
import React, { useState, useEffect, useRef } from 'react';
import style from './AppAlarmSetting.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import SwitchBox from '../../../../components/box/SwitchBox';
import Modal from '../../../../components/comm/Modal';
import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { setDpAuthPushInfo } from '../../../../assets/js/comm';

const AppAlarmSetting = () => {

    const [isOpen, setIsOpen] = useState(false);
    const [pendingPushToggle, setPendingPushToggle] = useState(false);

    const [pushAlarm, setPushAlarm] = useState(true);
    const [marketingAlarm, setMarketingAlarm] = useState(false);
    const [callAlarm, setCallAlarm] = useState(true);
    const [smsAlarm, setSmsAlarm] = useState(true);
    const [marketingPushAlarm, setMarketingPushAlarm] = useState(true);

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [notificationPermission, setNotificationPermission] = useState(null);
    const [isCheckingPermission, setIsCheckingPermission] = useState(false);
    const [pushToken, setPushToken] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const permissionRequestSourceRef = useRef(null);
    const prevPermissionRef = useRef(null);

    const fetchNotificationSettings = async () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        console.log("========> 알림 설정 조회 시작, usrInfoId: ", loginUser?.usrInfoId);

        if (!loginUser?.usrInfoId) {
            console.error("로그인 사용자 정보가 없습니다.");
            return;
        }

        const url = "/notifications";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };

        try {
            setIsLoading(true);
            const res = await axiosApi.post(url, {}, reqOptions);
            console.log("알림 설정 조회 결과:", res);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const settings = res.data.result.notificationSetting;
                console.log("설정 데이터:", settings);

                const isMarketingOn = settings.marktAlrmAt === '1';
                setMarketingAlarm(isMarketingOn);

                const isCallAlarmOn = settings.marktTelRcptnAt === '1';
                const isSmsAlarmOn = settings.marktSmsRcptnAt === '1';
                const isMarketingPushOn = settings.marktPushRcptnAt === '1';

                setCallAlarm(isCallAlarmOn);
                setSmsAlarm(isSmsAlarmOn);
                setMarketingPushAlarm(isMarketingPushOn);

                console.log("마케팅 알림 상태 설정:", {
                    main: isMarketingOn,
                    call: isCallAlarmOn,
                    sms: isSmsAlarmOn,
                    push: isMarketingPushOn
                });

                if (!isMarketingOn) {
                    setCallAlarm(false);
                    setSmsAlarm(false);
                    setMarketingPushAlarm(false);
                }

                setPushAlarm(settings.infoAlrmAt === '1');

            } else {
                console.error('알림 설정 조회 실패:', res.data.resultMessage);
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error('알림 설정 조회 에러:', err);
            alert('알림 설정을 불러오는데 실패했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    const updateNotificationSettings = async (settingsToUpdate) => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const url = "/notifications/setup";
        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            settings: settingsToUpdate
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };

        try {
            setIsLoading(true);
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log("알림 설정 업데이트 결과:", res);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                console.log('알림 설정 업데이트 성공');
            } else {
                console.error('알림 설정 업데이트 실패:', res.data.resultMessage);
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error('알림 설정 업데이트 에러:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const savePushTokenToServer = async (token) => {
        if (!token) return;

        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        if (!loginUser?.usrInfoId) return;

        try {
            // 자체 DB 토큰 저장
            const res1 = await axiosApi.post("/notifications/token", {
                pushTknVal: token,
                usrInfoId: loginUser.usrInfoId,
            }, {
                headers: { 'Authorization': 'Bearer ' + jToken }
            });
            console.log('자체 DB 토큰 저장:', res1.data.resultCode === CODE.RCV_SUCCESS ? '성공' : '실패');

            // DPAUTH 토큰 저장
            const res2 = await setDpAuthPushInfo(loginUser.usrUid, token);
            console.log('DPAUTH 토큰 저장:', res2);

        } catch (err) {
            console.error('푸시 토큰 서버 저장 실패:', err);
        }
    };

    const now = new Date();
    const yy = String(now.getFullYear()).slice(-2);
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const formattedDate = `${yy}.${mm}.${dd} ${hh}:${min}`;

    const isWebView = () => {
        return window.ReactNativeWebView ||
            navigator.userAgent.includes('wv') ||
            window.webkit?.messageHandlers;
    };

    const checkNotificationPermission = () => {
        if (window.ReactNativeWebView) {
            permissionRequestSourceRef.current = 'check';
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: 'CHECK_NOTIFICATION_PERMISSION' })
            );
        }
    };

    const getNativAlrmPermission = () => {
        setIsCheckingPermission(true);
        permissionRequestSourceRef.current = 'banner';

        if (window.ReactNativeWebView) {
            if (notificationPermission === false) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'OPEN_APP_SETTINGS' })
                );
            } else {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
                );
            }
        }

        setTimeout(() => {
            setIsCheckingPermission(false);
        }, 5000);
    };

    const handlePushToggle = (value) => {
        if (!value) {
            setPendingPushToggle(value);
            setIsOpen(true);
            return;
        }

        if (window.ReactNativeWebView) {
            setIsCheckingPermission(true);
            permissionRequestSourceRef.current = 'toggle';
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };

    const confirmTurnOffPush = () => {
        setPushAlarm(pendingPushToggle);
        setIsOpen(false);
        updateNotificationSettings({ 'INFO_ALRM_AT': '0' });
    };

    const cancelTurnOffPush = () => {
        setPendingPushToggle(false);
        setIsOpen(false);
    };

    const handleMarketingAlarmToggle = (value) => {
        setMarketingAlarm(value);
        setCallAlarm(value);
        setSmsAlarm(value);
        setMarketingPushAlarm(value);

        if (!value) {
            setToastMessage(`${formattedDate}\n혜택 정보 알림 수신을 철회했습니다.`);
            setToast(true);
            updateNotificationSettings({
                'MARKT_ALRM_AT': '0',
                'MARKT_TEL_RCPTN_AT': '0',
                'MARKT_SMS_RCPTN_AT': '0',
                'MARKT_PUSH_RCPTN_AT': '0'
            });
        } else {
            setToastMessage(`${formattedDate}\n혜택 정보 알림 수신을 동의했습니다.`);
            setToast(true);
            updateNotificationSettings({
                'MARKT_ALRM_AT': '1',
                'MARKT_TEL_RCPTN_AT': '1',
                'MARKT_SMS_RCPTN_AT': '1',
                'MARKT_PUSH_RCPTN_AT': '1'
            });
        }
    };

    const handleCallAlarmToggle = (value) => {
        const newCallAlarm = value;
        setCallAlarm(newCallAlarm);
        updateNotificationSettings({ 'MARKT_TEL_RCPTN_AT': value ? '1' : '0' });

        const allOff = !newCallAlarm && !smsAlarm && !marketingPushAlarm;
        const allOn = newCallAlarm && smsAlarm && marketingPushAlarm;

        if (allOff && marketingAlarm) {
            setMarketingAlarm(false);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '0' });
        } else if (allOn && !marketingAlarm) {
            setMarketingAlarm(true);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '1' });
        }
    };

    const handleSmsAlarmToggle = (value) => {
        const newSmsAlarm = value;
        setSmsAlarm(newSmsAlarm);
        updateNotificationSettings({ 'MARKT_SMS_RCPTN_AT': value ? '1' : '0' });

        const allOff = !callAlarm && !newSmsAlarm && !marketingPushAlarm;
        const allOn = callAlarm && newSmsAlarm && marketingPushAlarm;

        if (allOff && marketingAlarm) {
            setMarketingAlarm(false);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '0' });
        } else if (allOn && !marketingAlarm) {
            setMarketingAlarm(true);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '1' });
        }
    };

    const handleMarketingPushAlarmToggle = (value) => {
        const newMarketingPushAlarm = value;
        setMarketingPushAlarm(newMarketingPushAlarm);
        updateNotificationSettings({ 'MARKT_PUSH_RCPTN_AT': value ? '1' : '0' });

        const allOff = !callAlarm && !smsAlarm && !newMarketingPushAlarm;
        const allOn = callAlarm && smsAlarm && newMarketingPushAlarm;

        if (allOff && marketingAlarm) {
            setMarketingAlarm(false);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '0' });
        } else if (allOn && !marketingAlarm) {
            setMarketingAlarm(true);
            updateNotificationSettings({ 'MARKT_ALRM_AT': '1' });
        }
    };

    // ─── useEffect ───

    // 초기화 + 네이티브 메시지 리스너
    useEffect(() => {
        fetchNotificationSettings();

        const handleMessage = (event) => {
            const message = event.data;
            if (message?.type !== 'NOTIFICATION_PERMISSION_RESULT') return;

            console.log('권한 결과 수신:', message.granted, '출처:', permissionRequestSourceRef.current);
            setNotificationPermission(message.granted);
            setIsCheckingPermission(false);

            const source = permissionRequestSourceRef.current;
            permissionRequestSourceRef.current = null;

            // 토큰 있으면 항상 저장
            if (message.granted && message.token) {
                setPushToken(message.token);
                sessionStorage.setItem('pushToken', message.token);
            }

            // 토글 ON 요청일 때만 직접 DB 업데이트
            if (source === 'toggle') {
                if (message.granted) {
                    const token = message.token || sessionStorage.getItem('pushToken');
                    setPushAlarm(true);
                    updateNotificationSettings({ 'INFO_ALRM_AT': '1' });
                    if (token) savePushTokenToServer(token);
                } else {
                    alert('푸시 알림을 받으려면 휴대폰 설정에서 알림을 허용해주세요.');
                }
            }

            if (source === 'token_fetch' && message.granted && message.token) {
                savePushTokenToServer(message.token);
            }
        };

        const handleNativePermissionResult = (event) => {
            console.log('커스텀 이벤트 - 권한 결과:', event.detail);
            setNotificationPermission(event.detail.granted);
            setIsCheckingPermission(false);
        };

        window.addEventListener('message', handleMessage);
        window.addEventListener('nativePermissionResult', handleNativePermissionResult);

        if (isWebView()) {
            checkNotificationPermission();
        }

        return () => {
            window.removeEventListener('message', handleMessage);
            window.removeEventListener('nativePermissionResult', handleNativePermissionResult);
        };
    }, []);

    // 포그라운드 복귀 시 권한 재확인
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                setTimeout(() => {
                    checkNotificationPermission();
                }, 500);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    // 권한 전환 감지: false→true / true→false
    useEffect(() => {
        // false → true: 설정에서 권한 허용하고 돌아온 케이스
        if (prevPermissionRef.current === false && notificationPermission === true) {
            console.log('권한 false→true 전환 감지');
            setPushAlarm(true);
            updateNotificationSettings({ 'INFO_ALRM_AT': '1' });

            const token = sessionStorage.getItem('pushToken');
            if (token) {
                savePushTokenToServer(token);
            } else {
                // 토큰 없으면 REQUEST로 발급 요청
                permissionRequestSourceRef.current = 'token_fetch';
                window.ReactNativeWebView?.postMessage(
                    JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
                );
            }
        }

        // true → false: 설정에서 권한 해제
        if (prevPermissionRef.current === true && notificationPermission === false) {
            console.log("네이티브 권한 '꺼짐' 감지");
            setPushAlarm(false);
            updateNotificationSettings({ 'INFO_ALRM_AT': '0' });
        }

        prevPermissionRef.current = notificationPermission;
    }, [notificationPermission]);

    return (
        <>
            <HeadSub title="알림 설정" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    {!isWebView() ? (
                        <div className={style['top-box']}>
                            <div className={style['inner-box']}>
                                <div className={style['left']}>
                                    <p>모바일 앱 전용 서비스입니다</p>
                                    <span>
                                        이 기능은 모바일 앱에서만 <br />
                                        <b>이용하실 수 있습니다</b>
                                    </span>
                                </div>
                                <div className={style['right']}>
                                    <button
                                        className='btn'
                                        data-btn-size='sm'
                                        data-btn-type="fill-main"
                                        onClick={() => { }}
                                    >
                                        <span>앱 다운로드</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        !notificationPermission && (
                            <div className={style['top-box']}>
                                <div className={style['inner-box']}>
                                    <div className={style['left']}>
                                        <p>휴대폰 앱 알림 비허용 상태입니다</p>
                                        <span>
                                            잠금 화면에서 알림을 확인하려면 <br />
                                            <b> 앱 알림을 허용</b>해주세요.
                                        </span>
                                    </div>
                                    <div className={style['right']}>
                                        <button
                                            onClick={getNativAlrmPermission}
                                            className='btn'
                                            data-btn-size='sm'
                                            data-btn-type="fill-main"
                                            disabled={isCheckingPermission}
                                        >
                                            <span>
                                                {isCheckingPermission ? '확인 중...' : '설정 바로가기'}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    )}

                    <div className={style['push-alarm-box']}>
                        <div className={style['top']}>
                            <strong>푸시 알림</strong>
                            <SwitchBox
                                toggles={pushAlarm}
                                status={handlePushToggle}
                                disabled={isLoading}
                            />
                        </div>
                        <div className={style['mid']}>
                            <span>오늘 할 일, 진료 일정, 재택 치료 가이드, 건강 정보, 공지사항 알림을 휴대폰 알림으로 수신합니다.</span>
                            <span>해당 알림을 끄면 휴대폰 알림은 받을 수 없지만 앱 내 알림센터에서 알림 확인은 가능합니다.</span>
                        </div>
                    </div>

                    <div className={style['info-alarm-box']}>
                        <div className={style['top']}>
                            <strong>혜택 정보 알림</strong>
                            <SwitchBox
                                toggles={marketingAlarm}
                                status={handleMarketingAlarmToggle}
                                disabled={isLoading}
                            />
                        </div>
                        <span>마케팅 알림을 수신합니다.</span>
                        <div className={style['mid']}>
                            <ul>
                                <li>
                                    <p>전화 수신</p>
                                    <SwitchBox
                                        size="small"
                                        toggles={callAlarm}
                                        status={handleCallAlarmToggle}
                                        disabled={!marketingAlarm || isLoading}
                                    />
                                </li>
                                <li>
                                    <p>문자 수신</p>
                                    <SwitchBox
                                        size="small"
                                        toggles={smsAlarm}
                                        status={handleSmsAlarmToggle}
                                        disabled={!marketingAlarm || isLoading}
                                    />
                                </li>
                                <li>
                                    <p>휴대폰 푸시 알림 수신</p>
                                    <SwitchBox
                                        size="small"
                                        toggles={marketingPushAlarm}
                                        status={handleMarketingPushAlarmToggle}
                                        disabled={!marketingAlarm || isLoading}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>푸시 알림을 끄시겠어요?</p>
                        </div>
                        <div className='sub-box'>
                            <span>
                                푸시 알림을 끄면 <br />
                                휴대폰 앱 알림이 제공되지 않으며<br />
                                앱 내 알림센터에서만 알림 확인이 가능합니다.
                            </span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelTurnOffPush}>
                                <span>취소</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={confirmTurnOffPush}>
                                <span>끄기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                />
            )}
        </>
    );
};

export default AppAlarmSetting;